import styled, {keyframes} from 'styled-components';
import imgBG from '../../assets/images/BG_Page1.png';
import btnCircleMain from '../../assets/images/Button_Circle1.png';
import btnCircle from '../../assets/images/Button_Circle2.png';

const Page1Container = styled.div`
z-index: 1;
width: 100%;
height: 100%;
background-image: url(${imgBG});
background-size: contain;
background-repeat: no-repeat;
background-position: center;
`;

const rotate = keyframes`
	from { transform: translate(-50%, -50%) scale(1.4) rotate(0turn); }
	to { transform: translate(-50%, -50%) scale(1.4) rotate(1turn); }
`;

const clickAnimation = keyframes`
    0% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.1); }
    100% { transform: translate(-50%, -50%) scale(1); }
`;

const ButtonCircle = styled.div`
    --offset:1px;
    position: absolute;
    height: ${props => `calc( ${props.height || 565} / 4096 * 100vw)`};
    width: ${props => `calc( ${props.width || 565} / 4096 * 100vw)`};
    top: ${props => `calc( ${props.top || 968} / 2160 * 100vh)`};
    left: ${props => `calc( ${props.left || 1937} / 4096 * 100vw)`};
    transform: translate(-50%, -50%);
    max-width: 100%;
    border-radius: 10000px;
    overflow: hidden;
    background-image: url(${props => (props.isMain ? btnCircleMain : btnCircle)});
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.1s ease;
    animation: ${props => props.isClicked ? clickAnimation : 'none'} 0.3s ease;

    &::before {
        content: '';
        background: conic-gradient(transparent 270deg, ${props => props.rgb || 'rgb(255 255 255)'}, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        aspect-ratio: 1 / 1;
        width: 100%;
        animation: ${rotate} 2s linear infinite;
        pointer-events: none;
    }

    &::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
    }
    &:hover {
        cursor: pointer;
    }
`;

const TextButton = styled.p`
font-size: ${props => `calc( ${props.size || 50} / 4096 * 100vw)`};
font-weight: 1000;
color: white;
text-align: center;
    z-index: 10;
    margin-left: calc(20 / 2160 * 100vh);
        margin-right: calc(20 / 2160 * 100vh);

`;

export {Page1Container, ButtonCircle, TextButton};
